<template>
  <div ref="searchContainer">
    <div class="current-location cursor-pointer font-bold flex items-center gap-1" @click="showModal">
      <span>
        {{ currentState?.name || $t('usa') }}
      </span>
      <UIcon name="i-heroicons-map-pin"
          class=" text-xl search-geo-icon"
      />
    </div>
    <StateModal
        :show="show"
        @close="show = false"
    />
  </div>
</template>



<script lang="ts" setup>
import {ref, inject, type Ref} from 'vue';
import {PROVIDE_DARK_BG} from '~/utils/defs';
import {storeToRefs} from 'pinia';
import { useStateStore } from '~/store/state';

const show = ref<boolean>(false);

const showModal = () => {
  show.value = !show.value;
};

const darkBg = inject(PROVIDE_DARK_BG) as Ref<boolean>;
const searchContainer = ref<any>(null);
const stateStore = useStateStore();
const {currentState} = storeToRefs(stateStore);

useDeteckOutsideClick(searchContainer, () => {
  show.value = false;
  if (!darkBg.value) return;
  darkBg.value = false;
});

</script>

<style scoped lang="scss">

.row:not(:last-child) {
  border-bottom: 1px solid #ccc;
}

.button-events:deep(button),
.button-events:deep(.current-location),
.button-events:deep(span.i-heroicons-map-pin) {
  cursor: pointer;
  pointer-events: auto;
}
span.i-heroicons-map-pin {
  background-color: red;
}

.rounded-tl-md {
  border-top-left-radius: 0.375rem;
}

.rounded-br-md {
  border-bottom-left-radius: 0.375rem;
}

@media screen and (max-width: 650px) {
  .current-location {
    display: none;
  }
}

.searchWrapper {
  top: calc(100% + 15px);
}

</style>
